import { ReportModel } from 'src/app/Models/report-model';
import { ScenarioServiceService } from 'src/app/Services/scenario-service.service';
import { ScenarioModel } from 'src/app/Models/scenario-model';
import { SuiteModel } from 'src/app/Models/suite-model';
import { SuiteService } from 'src/app/Services/suite.service';

export class ReportMock {

  private static models: ReportModel[];
  private static  idCounter = 0;
  // public static suiteService: SuiteService;
  public static initMocks(){
    ReportMock.models = [];
    // let suite:SuiteModel=ReportMock.suiteService.findByObjectId("ebetbeetttbt");
    // let suite2:SuiteModel=ReportMock.suiteService.findByObjectId("wvwverbt4b4tb");
    //  ReportMock.models.push({id:"iu2gfin32f23", suite: new SuiteModel(), end_time:new Date(),start_time:new Date(),har:"",html:"",logs:"",video:"",summary:{feature:{passed:1,total:1},scenario:{passed:2,total:3},scenario_step:{passed:3,total:5}}}); 
    // ReportMock.models.push({id:"iu2gfin32f24", suite: suite2, end_time:new Date(),start_time:new Date(),har:"",html:"",logs:"",video:"",summary:{feature:{passed:2,total:5},scenario:{passed:6,total:11},scenario_step:{passed:7,total:8}}}); 
   }
  public static findByObjectId(id: string):ReportModel{
    let m = ReportMock.models;
    for(let i = 0; i< m.length; i++){
      if(id == m[i]._id) return m[i];
    }
    return null;
  }
  public static getItems():ReportModel[]{
    return ReportMock.models;
  }
}
